import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";

// Pages
import Main from "./pages/Main";
import PageNotFound from "./pages/PageNotFound";

// Antd
import { FloatButton } from "antd";

// Icons
import { ArrowUpOutlined } from "@ant-design/icons";

function App() {
  // const [loading, setLoading] = useState(false);
  const [showTopBtn, setShowTopBtn] = useState(false);

  const topbtnDisplay = () => {
    if (
      document.body.scrollTop > 50 ||
      document.documentElement.scrollTop > 50
    ) {
      setShowTopBtn(true);
    } else {
      setShowTopBtn(false);
    }
  };

  const backToTop = () => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  window.onscroll = function () {
    topbtnDisplay();
  };

  return (
    <div className="App">
      <div className="mobile-layout bg-black">
        <Header />
        <main>
          <Router>
            <Routes>
              <Route path="/:id" element={<Main />} />
              <Route path="/" element={<Main />} />
              <Route path="/page-not-found" element={<PageNotFound />} />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </Router>
        </main>
        <Footer />
      </div>
      {showTopBtn && (
        <FloatButton
          icon={<ArrowUpOutlined />}
          shape="square"
          onClick={backToTop}
        />
      )}
    </div>
  );
}

export default App;
